<template>
  <StandardLayout header="Subscriptions">
    <template v-slot:main>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="card-header">Neue Subscription</div>
            <div class="card-body">
              <SubscriptionEditor v-model="newSubscription"/>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <SubscriptionList :subscriptions="subscriptions" @delete="deleteSubscription($event)"/>
          <div class="text-center m-5" v-if="subscriptions.length === 0">keine Subscriptions vorhanden</div>
        </div>
      </div>
    </template>
  </StandardLayout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import SubscriptionList from "@/components/subscription/SubscriptionList";
import SubscriptionEditor from "@/components/subscription/SubscriptionEditor";


export default {
  components: {SubscriptionEditor, SubscriptionList, StandardLayout},
  data() {
    return {
      subscriptions: [],
      newSubscription: null
    }
  },
  methods: {
    loadSubscriptions() {
      this.$api.get('/subscriptions')
          .then(response => this.subscriptions = response.data)
          .catch(error => this.handleError(error))
    },
    postNewSubscription() {
      this.$api.post('/subscriptions', this.newSubscription)
          .then(() => {
            this.showInfo("Subscription erstellt")
            this.reset()
          }).catch(error => this.handleError(error))
    },
    deleteSubscription(subscriptionId) {
      this.$api.delete(`/subscriptions/${subscriptionId}`)
          .then(() => this.reset())
          .catch(err => this.handleError(err))
    },
    reset() {
      this.newSubscription = null
      this.loadSubscriptions()
    }
  },
  watch: {
    newSubscription(newValue) {
      if (newValue)
        this.postNewSubscription()
    }
  },
  activated() {
    this.loadSubscriptions()
  },
  mounted() {
    this.loadSubscriptions()
  }
}
</script>
